export default [
  {
    path: '/logistics',
    name: 'logistics.index',
    component: require('./index').default,
    meta: {
      title: '物流列表',
      navbar: 'el-icon-truck',
      permission: 'logistics.read'
    },
  },
  {
    path: '/logistics/:id',
    name: 'logistics.show',
    component: require('./show').default,
    meta: {
      title: '物流详情',
      permission: 'logistics.read'
    },
  }
]
